import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const BulkRepriceDialog = ({ open, onOpenChange, selectedCount, saving, onApply }) => {
  const { t } = useLanguage();
  const [price, setPrice] = useState('10');

  useEffect(() => {
    if (open) setPrice('10');
  }, [open]);

  const handleApply = () => {
    const parsed = parseFloat(price);
    if (Number.isNaN(parsed) || parsed < 0) return;
    onApply(parsed);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-card border-border max-w-sm">
        <DialogHeader>
          <DialogTitle>{t('admin.bulkRepriceDialogTitle')}</DialogTitle>
          <DialogDescription>
            {t('admin.bulkRepriceDialogDesc').replace('{n}', selectedCount)}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <div className="space-y-2">
            <Label htmlFor="bulk-price">{t('admin.price')}</Label>
            <Input
              id="bulk-price"
              type="number"
              step="0.50"
              min="0"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="bg-secondary border-border"
              data-testid="bulk-reprice-input"
              autoFocus
            />
          </div>
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => onOpenChange(false)} disabled={saving}>
              {t('common.cancel')}
            </Button>
            <Button
              onClick={handleApply}
              disabled={saving || price === ''}
              className="bg-primary hover:bg-primary/90"
              data-testid="bulk-reprice-apply"
            >
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
              {t('admin.bulkApply')}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
